module.exports = __webpack_public_path__ + "static/media/money-history-icon.d3f9b5d0.svg";